// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminResolveBookingResponse

export type AdminResolveBookingApiResponse = {
	businessId: string;
};

export type AdminResolveBooking = {
	businessId: string;
};

export function hydrateAdminResolveBooking(data: AdminResolveBookingApiResponse): AdminResolveBooking {
	return { ...data };
}